// extracted by mini-css-extract-plugin
module.exports = {"tagSetContainer":"TagSetContainer_tagSetContainer__2arTq","carrouselMode":"TagSetContainer_carrouselMode__3Z1ax"};